module.exports = __webpack_public_path__ + "assets/media/morning.41ffc37f.mp3";